<template>
  <PaneView>
    <template v-slot:left>
      <span>
        <div class="hidden-sm-and-down">
          <div class="left-header">
            <img
              src="../assets/logo.png"
              style="width: 100%; max-width: 40px;"
            />
            <!--          <button class="create-account-btn">Login</button>-->
          </div>
          <div class="biline-container">
            <div class="biline-title">
              Coach more, work less.
            </div>
            <div class="biline-subtitle">
              TeamBot is the premiere Team Management app that takes the
              frustration out of organizing schedules, availability, reminders,
              alerts, messaging, and more.
            </div>
          </div>
        </div>
        <div class="copyright">
          &copy; {{ new Date().getFullYear() }} TeamBot LLC
        </div>
        <privacy-terms-modal />
      </span>
    </template>
    <template v-slot:right>
      <v-row class="login-form-container">
        <v-spacer class="hidden-sm-and-down" />
        <v-col
          :cols="12"
          class="form-container col-lg-7 col-xl-6 col-md-10 col-sm-12 col-xs-12"
        >
          <img
            class="hidden-md-and-up mobile-logo"
            src="../assets/logo.png"
            style="width: 40px;"
          />
          <span style="width: 100%">
            <div class="_title">
              Sign up <br class="hidden-md-and-up" />for TeamBot.
            </div>
            <!--            <div class="_subtitle hidden-sm-and-down">-->
            <!--              Enter your details below.-->
            <!--            </div>-->
            <v-form ref="form">
              <!--              <v-text-field v-model="signup" name="signup" type="hidden" value="1"/>-->
              <div
                class="row d-flex flex-xs-column flex-sm-row flex-md-row px-3"
              >
                <v-text-field
                  id="firstName"
                  ref="firstName"
                  v-model="firstName"
                  :rules="fieldRequired"
                  class="fields"
                  dense
                  flat
                  name="firstName"
                  placeholder="First Name"
                  required
                  solo
                />
                <div class="hidden-xs-only mr-2" />
                <v-text-field
                  id="lastName"
                  ref="lastName"
                  v-model="lastName"
                  :rules="fieldRequired"
                  class="fields"
                  dense
                  flat
                  name="lastName"
                  placeholder="Last Name"
                  required
                  solo
                />
              </div>
              <div>
                <v-text-field
                  id="useremail"
                  ref="email"
                  v-model="email"
                  :rules="emailRules"
                  class="fields"
                  dense
                  flat
                  name="email"
                  placeholder="Email"
                  required
                  solo
                />
              </div>
              <div>
                <v-text-field
                  id="userMobilePhone"
                  ref="mobilePhone"
                  v-model="mobilePhone"
                  :rules="fieldRequired"
                  class="fields"
                  dense
                  flat
                  name="mobilePhone"
                  placeholder="Mobile Phone"
                  required
                  solo
                />
              </div>

              <div>
                <v-autocomplete
                  ref="mobileCarrier"
                  v-model="mobileCarrier"
                  :items="phoneCarriers.map(val => val.label)"
                  :rules="[() => !!mobileCarrier || 'This field is required']"
                  class="fields"
                  color="white"
                  dense
                  flat
                  name="mobilePhoneCarrier"
                  placeholder="Select Carrier to Receive Text Alerts from Coach"
                  required
                  solo
                />
              </div>

              <div
                class="row d-flex flex-xs-column flex-sm-row flex-md-row px-3"
              >
                <v-text-field
                  id="password"
                  ref="pass"
                  v-model="pass"
                  :append-icon="showPass ? 'mdi-eye' : 'mdi-eye-off'"
                  :rules="[rules.required, rules.min]"
                  :type="showPass ? 'text' : 'password'"
                  class="fields input-group--focused"
                  dense
                  flat
                  name="password"
                  placeholder="Password"
                  required
                  solo
                  @click:append="showPass = !showPass"
                />
                <div class="hidden-xs-only mr-2" />
                <v-text-field
                  id="confirm-password"
                  ref="confirmPass"
                  v-model="confirmPass"
                  :append-icon="showCPass ? 'mdi-eye' : 'mdi-eye-off'"
                  :rules="[rules.required, rules.min, rules.passMatch]"
                  :type="showCPass ? 'text' : 'password'"
                  class="fields input-group--focused"
                  dense
                  flat
                  name="confirm-password"
                  placeholder="Confirm Password"
                  required
                  solo
                  @click:append="showCPass = !showCPass"
                />
              </div>

              <div class="d-flex justify-end">
                <div style="width: 304px">
                  <div class="form-group required recaptcha">
                    <VueRecaptcha
                      ref="recaptcha"
                      :loadRecaptchaScript="true"
                      sitekey="6LeRMb4UAAAAABYuBWW8GwVpiG3OqT7NYlVssbTB"
                      @verify="onVerify"
                    >
                    </VueRecaptcha>
                    <span :class="[showCaptchaError ? 'error--text' : 'd-none']"
                      >*Required</span
                    >
                  </div>
                  <div
                    id="captchaError"
                    class="alert alert-danger"
                    style="display:none;"
                  ></div>
                </div>
              </div>
            </v-form>

            <v-row class="login-btn-container">
              <v-col
                :cols="12"
                class="col-md-7 col-lg-7 col-xl-7 order-xs-1 order-sm-1 order-md-0 order-lg-0 order-xl-0"
              >
                <span class="new-user-hint"
                  >Already have an account?
                  <a class="create-account-link" @click="$router.push('/login')"
                    >Login</a
                  ></span
                >
              </v-col>
              <v-col
                :cols="12"
                class="col-md-5 col-lg-5 col-xl-5 d-flex justify-end"
              >
                <button class="tb-primary-btn" @click="signUp">Sign Up</button>
              </v-col>
            </v-row>
          </span>
        </v-col>
        <v-spacer class="hidden-sm-and-down" />
      </v-row>
    </template>
  </PaneView>
</template>
<script lang="ts">
import Vue from 'vue'
import PaneView from '../template/PaneView.vue'
import privacyTermsModal from '../components/privacy-terms-modal.vue'
import axios from 'axios'
import { buildRedirectUriFromParams } from '../utils/HttpUtils.js'
import { mobileProviders } from '../helpers/MobileCarriers.js'
import VueRecaptcha from 'vue-recaptcha'
import { bus } from '../main.js'

export default Vue.extend({
  name: 'Signup',
  metaInfo: {
    title: 'Register'
  },
  components: { PaneView, privacyTermsModal, VueRecaptcha },
  data () {
    return {
      formHasErrors: false,
      showPass: false,
      showCPass: false,
      phoneCarriers: [],
      selected: '',
      loginEmail: '',
      loginPass: '',
      loginRememberMe: false,
      signup: '1',
      firstName: '',
      lastName: '',
      email: '',
      mobilePhone: '',
      mobileCarrier: '',
      pass: '',
      confirmPass: '',
      rememberMeBox: false,
      recaptcha: false,
      showCaptchaError: false,
      fieldRequired: [v => !!v || 'This field is Required'],
      emailRules: [
        v => !!v || 'This field is required',
        v => /.+@.+\..+/.test(v) || 'E-mail must be valid'
      ],
      rules: {
        required: value => !!value || '*Required',
        min: v => v.length >= 8 || 'Min 8 characters',
        passMatch: value => value === this.pass || "Passwords don't match"
      }
    }
  },
  methods: {
    onVerify () {
      this.recaptcha = true
      this.showCaptchaError = false
    },
    getPhoneCarriers () {
      this.phoneCarriers = mobileProviders
    },
    validateItems () {
      if (this.$refs.form.validate()) {
        if (this.recaptcha) {
          this.signUp()
        } else {
          this.showCaptchaError = true
        }
      }
    },
    signUp () {
      bus.$emit('loading-on')
      const carrier = this.phoneCarriers.filter(
        val => val.label === this.mobileCarrier
      )
      axios
        .post('/security-api/account', {
          signup: '1',
          firstName: this.firstName,
          lastName: this.lastName,
          email: this.email.trim(),
          mobilePhone: this.mobilePhone,
          mobilePhoneCarrier: carrier[0].value,
          password: this.pass,
          confirmPassword: this.confirmPass,
          rememberMe: this.rememberMeBox
        })
        .then(response => {
          this.loading = false
          window.location.href = this.$route.query.redirectUri
            ? buildRedirectUriFromParams(this.$route.query)
            : '/today'
        })
        .catch(reason => {
          const snackText =
            reason.response &&
            reason.response.data &&
            reason.response.data.errors
              ? `Error: ${reason.response.data.errors[0].message}`
              : 'An error has occurred'
          bus.$emit('loading-off')
          bus.$emit('error', snackText)
        })
    }
  },
  mounted () {
    this.getPhoneCarriers()
  }
})
</script>
<style>
/* BEGIN: register page field styling */
.fields.v-text-field input {
  color: white !important;
}
.fields.v-text-field input:focus {
  color: black !important;
}
.fields.v-text-field input::placeholder {
  color: rgba(255, 255, 255, 0.5) !important;
}
.fields.v-text-field input:focus::placeholder {
  color: rgba(0, 0, 0, 0.75) !important;
}
.fields.v-text-field > .v-input__control > .v-input__slot {
  background-color: #213343 !important;
}
.fields.v-text-field > .v-input__control > .v-input__slot:focus-within {
  background-color: white !important;
}
.fields .v-icon {
  color: rgba(255, 255, 255, 0.5) !important;
}
/* END: register page field styling */
</style>
<style scoped>
.biline-container {
  margin: 30px 35px;
  position: relative;
  width: 350px;
}
.biline-title {
  font-size: 32px;
  font-weight: 500;
  color: white;
}
.biline-subtitle {
  margin-top: 2px;
  font-size: 18px;
  color: rgba(255, 255, 255, 0.9);
}
.copyright {
  position: absolute;
  bottom: 0;
  left: 0;
  margin: 20px 35px;
  font-size: 12px;
  color: rgba(255, 255, 255, 0.7);
}
.left-header {
  position: relative;
  margin: 20px 35px;
  width: 82%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}
.form-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
}
.login-form-container {
  position: relative;
  z-index: 2;
  height: 100%;
  align-items: center;
}

.login-btn-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 0px;
  color: white;
}
.login-btn {
  position: relative;
  width: 200px;
  height: 40px;
  background-color: #07cb69;
  font-size: 18px;
  border-radius: 20px 20px 20px 20px;
  filter: drop-shadow(0px 3px 5px rgba(7, 203, 105, 0.6));
}
.create-account-link {
  padding-left: 3px;
  color: white;
  text-decoration: underline;
  text-underline-style: single;
  text-underline: white;
}
</style>
